<!-- 底部 -->
<template>
  <div class="footer">
    <div class="center-box">
      <el-row justify="space-between">
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div class="footer-left">
            <p>地址：{{ dataList.address }}</p>
            <p>邮编：{{ dataList.postcode }}</p>
            <p>联系电话：{{ dataList.phone }}</p>
            <p>网址：{{ dataList.website }}</p>
            <p>Email:{{ dataList.email }}</p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div class="footer-center">
            <img :src="dataList.logo_img" alt="校标" />
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div class="footer-right">
            <p>{{ dataList.copyright }}</p>
            <p>{{ dataList.beian_code }}</p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getSiteInfo } from "@/api/home";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      img1: "",
      img2: "",
      dataList: {},
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    fetchData() {
      getSiteInfo({ type: 3 }).then((response) => {
        this.dataList = response.data;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.fetchData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang="scss" scoped>
.footer {
  background-color: #01458e;
  font-size: 14px;
  height: 100%;
  color: #ffffff;
  div {
    p {
      margin-bottom: 10px;
    }
  }
  .footer-center {
    height: 170px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 110px;
      height: 110px;
    }
  }
  .footer-left {
    height: 170px;
    padding-top: 20px;
    @media screen and (max-width: 1000px) {
      text-align: center;
      height: 150px;
    }
  }
  .footer-right {
    height: 170px;
    padding-top: 20px;
    text-align: right;
    @media screen and (max-width: 1000px) {
      text-align: center;
      height: 150px;
    }
  }
}
</style>
